import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';

/**
 * Возвращает функцию, которая заставляет функциональный компонент перерендериться
 */
export var useForceUpdate = function useForceUpdate() {
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    setRnd = _React$useState2[1];
  return function () {
    return setRnd(Math.random());
  };
};